import { TRPCClientError } from "@trpc/client"

// Statuses not worth retrying: 4xx fail identically on the same input, and hammering
// an unavailable/gateway-timed-out upstream amplifies the outage.
const DO_NOT_RETRY_STATUSES = new Set<number>([400, 401, 403, 404, 503, 504])

// tRPC-aware retry policy for React Query. The upstream status lives in
// `error.data.httpStatus` (not `error.statusCode`), so generic status-based policies
// miss it and retry everything; this one reads the right field.
export function trpcRetry(maxRetries: number) {
  return (failureCount: number, error: unknown): boolean => {
    if (failureCount >= maxRetries) return false

    // Client-side abort / torn socket — no upstream response to reason about.
    if (error instanceof Error && error.name === "AbortError") return false

    if (error instanceof TRPCClientError) {
      const status = (error.data as { httpStatus?: number } | undefined)?.httpStatus
      if (status != null && DO_NOT_RETRY_STATUSES.has(status)) return false
    }

    return true
  }
}
